import {
    DELETE_TEAM_MEMBERS_FAILURE,
    DELETE_TEAM_MEMBERS_SUCCESS,
    DELETE_TEAM_MEMBERS_REQUEST,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteTeamMembersByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_TEAM_MEMBERS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_TEAM_MEMBERS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_TEAM_MEMBERS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteTeamMembersByAdminReducer;
